import { getComponentForKey as commonComponentForKey } from "../../generic/Utils/commonFilterUtils";
import { WidgetUId } from "./constants";
import * as ObjectExtensions from "../../../utils/CoreExtensions/ObjectExtensions";

import EnrollmentOverview from "./EnrollmentOverview";
import UsersAwaitingSignup from "./UsersAwaitingSignup";
import MembershipApplications from "./MembershipApplications";
import UnpublishedUsers from "./UnpublishedUsers";
import MembershipRequestsReceivedTrend from "./MembershipRequestsReceivedTrend";
import PublishedUsers from "./PublishedUsers";
import MatchingOverview from "./MatchingOverview";
import OngoingMatchingStatus from "./OngoingMatchingStatus";
import OnetimeMatchingStatus from "./OnetimeMatchingStatus";
import ProgramInvitations from "./ProgramInvitations";
import MentorMenteeAvailability from "./MentorMenteeAvailability";
import DraftedConnectionsStatus from "./DraftedConnectionsStatus";
import ConnectionStatus from "./ConnectionStatus";
import MeetingStatus from "./MeetingStatus";
import MentoringRequestsStatus from "./MentoringRequestsStatus";
import MeetingRequestsStatus from "./MeetingRequestsStatus";
import NeverConnectedMenteesOngoing from "./NeverConnectedMenteesOngoing";
import OngoingConnectionStatus from "./OngoingConnectionStatus";
import EngagementSurveys from "./EngagementSurveys";
import MeetingSurveys from "./MeetingSurveys";
import NeverConnectedMenteesOneTime from "./NeverConnectedMenteesOneTime";
import ProjectRequestsStatus from "./ProjectRequestsStatus";
import MeetingFeedbacks from "./MeetingFeedbacks";
import InAWordResponses from "./InAWordResponses";
import SiloBusting from "./SiloBusting";

export const widgetKeyToComponentMap = {
  [WidgetUId.ENROLLMENT_OVERVIEW]: EnrollmentOverview,
  [WidgetUId.MEMBERSHIP_APPLICATIONS]: MembershipApplications,
  [WidgetUId.USERS_AWAITING_SIGNUP]: UsersAwaitingSignup,
  [WidgetUId.UNPUBLISHED_USERS]: UnpublishedUsers,
  [WidgetUId.MEMBERSHIP_REQUESTS_RECEIVED_TREND]: MembershipRequestsReceivedTrend,
  [WidgetUId.PUBLISHED_USERS]: PublishedUsers,
  [WidgetUId.MATCHING_OVERVIEW]: MatchingOverview,
  [WidgetUId.PROGRAM_INVITATIONS]: ProgramInvitations,
  [WidgetUId.MENTOR_MENTEE_AVAILABILITY]: MentorMenteeAvailability,
  [WidgetUId.CONNECTION_STATUS]: ConnectionStatus,
  [WidgetUId.MEETING_STATUS]: MeetingStatus,
  [WidgetUId.DRAFTED_CONNECTIONS_STATUS]: DraftedConnectionsStatus,
  [WidgetUId.ONGOING_MATCHING_STATUS]: OngoingMatchingStatus,
  [WidgetUId.ONETIME_MATCHING_STATUS]: OnetimeMatchingStatus,
  [WidgetUId.MENTORING_REQUESTS_STATUS]: MentoringRequestsStatus,
  [WidgetUId.MEETING_REQUESTS_STATUS]: MeetingRequestsStatus,
  [WidgetUId.NEVER_CONNECTED_MENTEES_ONGOING]: NeverConnectedMenteesOngoing,
  [WidgetUId.ONGOING_CONNECTION_STATUS]: OngoingConnectionStatus,
  [WidgetUId.ENGAGEMENT_SURVEYS]: EngagementSurveys,
  [WidgetUId.MEETING_SURVEYS]: MeetingSurveys,
  [WidgetUId.NEVER_CONNECTED_MENTEES_ONE_TIME]: NeverConnectedMenteesOneTime,
  [WidgetUId.PROJECT_REQUESTS_STATUS]: ProjectRequestsStatus,
  [WidgetUId.ONGOING_MEETING_FEEDBACKS]: MeetingFeedbacks,
  [WidgetUId.ONE_TIME_MEETING_FEEDBACKS]: MeetingFeedbacks,
  [WidgetUId.IN_A_WORD_RESPONSES]: InAWordResponses,
  [WidgetUId.SILO_BUSTING]: SiloBusting
};

export const getWidgetDataFromArray = (widgets, widgetUId) => {
  return widgets.find((widget) => widget.uId === widgetUId);
};

export const getComponentForKey = (key) => {
  return commonComponentForKey(key, widgetKeyToComponentMap);
};

export const getDefaultWidgetConfigs = (data = {}) => {
  const internalSelector = data.uId ? `cdev-${data.uId}` : "";
  return {
    className: `grid-element-lg ${data.className} ${internalSelector}`,
    loadersCount: data.possibleMetricsCount,
    waitDuringMultipleRequests: data.waitDuringMultipleRequests
  };
};

export const getRemoteConfigs = (url, Component, urlOptions = {}) => {
  return {
    remote: true,
    remoteOptions: {
      url: url,
      urlOptions: urlOptions,
      component: Component
    }
  };
};

export const getExportFileName = (widgetName) => {
  const dateString = `${moment().format('MM-DD-yyyy')}`;
  return `${widgetName}-${dateString}`;
}

export const getEventDetailsHash = (options = {}) => {
  return {
    eventName: options.eventName,
    payload: ObjectExtensions.pick(options, "source", "preset", "dateRange", "eventCategory")
  };
}